module.exports = __webpack_public_path__ + "static/media/operations-feature-3.c2022d8d.svg";